import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  spaceXLarge,
  fontFamilies,
  fontWeights,
}: Theme) => ({
  root: {
    padding: `${spaceXLarge} 0`,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  subtitle: {
    margin: `${spaceXLarge} 0 2.5rem`,
    fontFamily: fontFamilies.primary,
    fontWeight: fontWeights.regular,
    fontSize: '2.375rem',
    lineHeight: 1.1,
  },
}));
